'use strict';

angular.module('imagetrend.components')
    .directive('hlpAutoNumber', ['Format', 'AutoNumbers', function (Format, AutoNumbers) {
        return {
            restrict: 'AE',
            scope: {
                licenseId: '=?',
                licenseCategoryId: '=?',
                autoNumber: '=?',

                //disabled
                isDisabled: '=?',

                //attributes
                name: '@?',
                id: '@?',
                showLinks: '@?',

                //label
                showLabel: '@?',
                label: '@?',
            },
            replace: true,
            templateUrl: 'templates/auto-number/auto-number.html',
            link: function (scope, elem, attrs, ctrl) {
                //attributes
                if (!attrs.name) { attrs.name = 'auto_number'; }
                if (!attrs.id) { attrs.id = attrs.name; }

                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.showLinks) { attrs.showLinks = false; } else { if (attrs.showLinks == 'true') { attrs.showLinks = true; } else { attrs.showLinks = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }

                //disabled
                if (scope.isDisabled == undefined) { scope.isDisabled = false; }

                scope.$watch('licenseId + licenseCategoryId', function () {
                    if (scope.autoNumber == undefined && (scope.licenseId != undefined || scope.licenseCategoryId != undefined)) {
                        AutoNumbers.get(scope.licenseId, scope.licenseCategoryId).then(function (auto_number) {
                            if (Array.isArray(auto_number) && auto_number.length > 0) {
                                scope.autoNumber = auto_number[0];
                            }
                            else {
                                scope.autoNumber = auto_number;
                            }
                        })                        
                    }
                })

                scope.dateFormats = [
                    { name: 'none', id: null },
                    { name: 'yy', id: 'yy' },
                    { name: 'yyyy', id: 'yyyy' },
                    { name: 'yymm', id: 'yymm' },
                    { name: 'yymmdd', id: 'yymmdd' },
                    { name: 'yyyymmdd', id: 'yyyymmdd' }
                ];
                scope.ruleFormats = [
                    { name: 'XXX', id: 'XXX' },
                    { name: 'XXXX', id: 'XXXX' },
                    { name: 'XXXXX', id: 'XXXXX' },
                    { name: 'XXXXXX', id: 'XXXXXX' },
                    { name: 'XXXXXXX', id: 'XXXXXXX' },
                    { name: 'XXXXXXXX', id: 'XXXXXXXX' },
                    { name: 'XXXXXXXXX', id: 'XXXXXXXXX' },
                    { name: 'XXXXXXXXXX', id: 'XXXXXXXXXX' },
                    { name: 'XXXXXXXXXXX', id: 'XXXXXXXXXXX' }
                ];

                scope.Date = function () {
                    return new Date();
                }

                scope.FormatNumber = function (number, rule) {
                    var numberFormatted = number;

                    if (rule !== undefined && number !== undefined) {
                        for (var i = 0; i < rule.length - number.toString().length; i++)
                            numberFormatted = '0' + numberFormatted;
                    }

                    return numberFormatted;
                }

                scope.FormatDate = function (dateFormat) {
                    var format = dateFormat;

                    if (format == 'none') {
                        format = null;
                    }
                    else if (format == 'yymm') {
                        format = 'yyMM'
                    }
                    else if (format == 'yymmdd') {
                        format = 'yyMMdd'
                    }
                    else if (format == 'yyyymmdd') {
                        format = 'yyyyMMdd'
                    }

                    return format;
                }
            }
        };
    }])
;